var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSendtophotographer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-76d62c27-35b7-460d-b5e1-3f83cc353702",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.99 72.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.94,3.94l-10.12,60.75c-.37,2.15-2.64,3.4-4.64,2.56l-17.52-7.34-8.93,10.87c-1.97,2.41-5.98,1.1-5.98-2.22v-11.32L58.63,15.97c.66-.8-.44-1.86-1.21-1.17L17.01,50.4l-14.95-6.27c-2.53-1.07-2.85-4.61-.31-6.08L66.94,.45c2.43-1.41,5.48,.65,5.01,3.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSendtophotographer);
export default __webpack_public_path__ + "static/media/dark - send to photographer.3109ebc637a96476d224093d7df4a3f2.svg";
export { ForwardRef as ReactComponent };